<div class="hist-dashboard" *ngIf="variant === 'dashboard'">
    <div class="kpi-row">
        <div class="kpi-card">
            <span class="kpi-icon-badge" style="background:#dcfce7;"><img src="assets/img/icons/kpi-salario-diario.svg" alt=""></span>
            <div class="kpi-body">
                <p class="kpi-label">Salario diario actual</p>
                <p class="kpi-value">{{formatCurrency(latestRow?.daily_salary)}}</p>
                <p class="kpi-sub">Desde el {{formatDate(latestRow?.movement_date)}}</p>
            </div>
        </div>
        <div class="kpi-card">
            <span class="kpi-icon-badge" style="background:#dbeafe;"><img src="assets/img/icons/kpi-sdi-imss.svg" alt=""></span>
            <div class="kpi-body">
                <p class="kpi-label">SDI IMSS actual</p>
                <p class="kpi-value">{{formatCurrency(latestRow?.imss_sdi)}}</p>
                <p class="kpi-sub">Desde el {{formatDate(latestRow?.movement_date)}}</p>
            </div>
        </div>
        <div class="kpi-card">
            <span class="kpi-icon-badge" style="background:#f3e8ff;"><img src="assets/img/icons/kpi-ultimo-movimiento.svg" alt=""></span>
            <div class="kpi-body">
                <p class="kpi-label">Ultimo movimiento</p>
                <p class="kpi-value">{{formatDate(latestRow?.movement_date)}}</p>
                <p class="kpi-sub">{{daysSinceLastMovement}}</p>
            </div>
        </div>
        <div class="kpi-card">
            <span class="kpi-icon-badge" style="background:#ffedd4;"><img src="assets/img/icons/kpi-total-movimientos.svg" alt=""></span>
            <div class="kpi-body">
                <p class="kpi-label">Total de movimientos</p>
                <p class="kpi-value">{{rows.length}}</p>
                <p class="kpi-sub">En el historial</p>
            </div>
        </div>
    </div>

    <div class="dashboard-filters-row">
        <div class="date-range-field">
            <label>Rango de fechas</label>
            <div class="date-range-select">
                <select [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange()">
                    <option *ngFor="let opt of dateRangeOptions" [value]="opt">{{opt}}</option>
                </select>
                <img src="assets/img/icons/icon-chevron-down.svg" alt="">
            </div>
        </div>
        <button type="button" class="hist-options-btn" (click)="exportCsv()">
            <img src="assets/img/icons/icon-more-options.svg" alt=""> Exportar
        </button>
    </div>

    <div class="chart-card">
        <div class="chart-card-header">
            <div>
                <p class="chart-title">Evolución del salario diario</p>
                <p class="chart-subtitle">Gráfica de los cambios de salario en el periodo seleccionado</p>
            </div>
            <div class="chart-legend">
                <span class="chart-legend-dot"></span>
                <span>Salario diario</span>
            </div>
        </div>
        <div class="chart-canvas-wrap">
            <canvas #salaryChartCanvas></canvas>
        </div>
    </div>

    <div class="movements-section">
        <p class="movements-title">Historial de movimientos</p>
        <div class="hist-table-wrap" *ngIf="!loading && !loadError">
            <table class="hist-table hist-table-dashboard">
                <thead>
                    <tr>
                        <th>Tipo de movimiento</th>
                        <th>Fecha del movimiento</th>
                        <th class="text-center">Salario diario</th>
                        <th class="text-center">SDI IMSS</th>
                        <th class="text-center">Parte fija</th>
                        <th class="text-center">Parte variable</th>
                        <th class="text-center">Usuario</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of rangedRows">
                        <td>
                            <span class="movement-badge" [ngClass]="'movement-badge-' + (row.movement_type === 'Alta' ? 'alta' : 'default')">{{row.movement_type}}</span>
                        </td>
                        <td>{{formatDate(row.movement_date)}}</td>
                        <td class="text-center">{{formatCurrency(row.daily_salary)}}</td>
                        <td class="text-center">{{formatCurrency(row.imss_sdi)}}</td>
                        <td class="text-center">{{formatCurrency(row.fixed_part)}}</td>
                        <td class="text-center">{{formatCurrency(row.variable_part)}}</td>
                        <td class="text-center">{{row.user?.name || '--'}}</td>
                    </tr>
                    <tr *ngIf="!rangedRows.length">
                        <td colspan="7" class="text-center text-muted py-4">Sin movimientos de salario registrados</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="hist-empty-state" *ngIf="loading">
            <i class="ti ti-loader-2"></i>
            <p class="mb-0">Cargando historial de salarios...</p>
        </div>
        <div class="hist-empty-state" *ngIf="loadError">
            <i class="ti ti-file-x"></i>
            <p class="mb-0">No se pudo cargar el historial de salarios.</p>
        </div>
    </div>
</div>

<div class="hist-card" *ngIf="variant === 'compact'">
    <div class="hist-info-banner">
        <img src="assets/img/icons/icon-info.svg" alt="">
        <span>No se incluyen cambios de SDI por percepciones fijas de la nómina actual.</span>
    </div>

    <div class="hist-toolbar">
        <div class="hist-search-box">
            <img src="assets/img/icons/icon-search.svg" alt="">
            <input type="text" placeholder="Buscar..." [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()">
        </div>
        <div class="hist-toolbar-actions">
            <div class="hist-options-dropdown" (click)="$event.stopPropagation()">
                <button type="button" class="hist-options-btn" (click)="toggleActionsDropdown()">
                    <img src="assets/img/icons/icon-more-options.svg" alt=""> Opciones
                </button>
                <ul class="dropdown-menu hist-options-menu" [class.show]="actionsOpen">
                    <li><button class="dropdown-item" type="button" (click)="exportCsv()">Exportar CSV</button></li>
                </ul>
            </div>
            <button type="button" class="hist-add-btn" *ngIf="canDo('Editar')" (click)="openAddModal()">
                <img src="assets/img/icons/icon-plus.svg" alt=""> Agregar movimiento
            </button>
        </div>
    </div>

    <div class="hist-table-wrap" *ngIf="!loading && !loadError">
        <table class="hist-table">
            <thead>
                <tr>
                    <th>Tipo de movimiento</th>
                    <th>Fecha del movimiento</th>
                    <th class="text-end">Salario diario</th>
                    <th class="text-end">SDI IMSS</th>
                    <th class="text-end">Parte fija</th>
                    <th class="text-end">Parte variable</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of pagedRows">
                    <td>{{row.movement_type}}</td>
                    <td>{{formatDate(row.movement_date)}}</td>
                    <td class="text-end">{{formatCurrency(row.daily_salary)}}</td>
                    <td class="text-end">{{formatCurrency(row.imss_sdi)}}</td>
                    <td class="text-end">{{formatCurrency(row.fixed_part)}}</td>
                    <td class="text-end">{{formatCurrency(row.variable_part)}}</td>
                </tr>
                <tr *ngIf="!filteredRows.length">
                    <td colspan="6" class="text-center text-muted py-4">Sin movimientos de salario registrados</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="hist-empty-state" *ngIf="loading">
        <i class="ti ti-loader-2"></i>
        <p class="mb-0">Cargando historial de salarios...</p>
    </div>

    <div class="hist-empty-state" *ngIf="loadError">
        <i class="ti ti-file-x"></i>
        <p class="mb-0">No se pudo cargar el historial de salarios.</p>
    </div>

    <div class="hist-pagination" *ngIf="!loading && !loadError && filteredRows.length">
        <div class="hist-page-size">
            <span>Filas por página:</span>
            <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                <option *ngFor="let s of pageSizeOptions" [value]="s">{{s}}</option>
            </select>
        </div>
        <div class="hist-pager">
            <button type="button" class="hist-pager-btn" [disabled]="currentPage === 1" (click)="prevPage()">
                <i class="ti ti-chevron-left"></i>
            </button>
            <span class="hist-pager-current">{{currentPage}}</span>
            <button type="button" class="hist-pager-btn" [disabled]="currentPage === totalPages" (click)="nextPage()">
                <i class="ti ti-chevron-right"></i>
            </button>
        </div>
    </div>
</div>

<div class="modal fade" id="salaryMovementModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content hist-modal-content">
            <button type="button" class="hist-modal-close" (click)="closeAddModal()" aria-label="Cerrar">
                <i class="ti ti-x"></i>
            </button>
            <h4 class="hist-modal-title">Agregar movimiento</h4>

            <form [formGroup]="form" (ngSubmit)="save()">
                <div class="field-row">
                    <div class="field-col">
                        <label class="field-label">Tipo de movimiento</label>
                        <select class="field-select" [class.is-invalid]="submitted && f['movement_type'].invalid"
                            formControlName="movement_type">
                            <option value="" disabled>Seleccionar</option>
                            <option *ngFor="let t of movementTypes" [value]="t">{{t}}</option>
                        </select>
                        <div class="hist-field-error" *ngIf="submitted && f['movement_type'].invalid">
                            El tipo de movimiento es obligatorio
                        </div>
                    </div>
                    <div class="field-col">
                        <label class="field-label">Fecha del movimiento</label>
                        <app-date-picker class="field-input" [class.is-invalid]="submitted && f['movement_date'].invalid"
                            formControlName="movement_date"></app-date-picker>
                        <div class="hist-field-error" *ngIf="submitted && f['movement_date'].invalid">
                            La fecha del movimiento es obligatoria
                        </div>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col">
                        <label class="field-label">Salario diario</label>
                        <input type="number" step="0.01" class="field-input"
                            [class.is-invalid]="submitted && f['daily_salary'].invalid" formControlName="daily_salary">
                        <div class="hist-field-error" *ngIf="submitted && f['daily_salary'].invalid">
                            El salario diario es obligatorio
                        </div>
                    </div>
                    <div class="field-col">
                        <label class="field-label">SDI IMSS</label>
                        <input type="number" step="0.01" class="field-input" formControlName="imss_sdi">
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col">
                        <label class="field-label">Parte fija</label>
                        <input type="number" step="0.01" class="field-input" formControlName="fixed_part">
                    </div>
                    <div class="field-col">
                        <label class="field-label">Parte variable</label>
                        <input type="number" step="0.01" class="field-input" formControlName="variable_part">
                    </div>
                </div>

                <div class="hist-modal-actions">
                    <button type="button" class="hist-btn hist-btn-secondary" (click)="closeAddModal()">Cancelar</button>
                    <button type="submit" class="hist-btn hist-btn-primary">Guardar movimiento</button>
                </div>
            </form>
        </div>
    </div>
</div>
